import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=30c3c278&scoped=true"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=30c3c278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c3c278",
  null
  
)

export default component.exports